import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { CLHospitalApi } from 'api/CL/CLHospitalApi';
import { useLoginStore } from 'store/useLoginDataStore';

const getAxiosErrorMessage = (error: unknown) => {
    if (!axios.isAxiosError(error)) {
        return error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
    }

    const responseData = error.response?.data as { message?: string; error?: { message?: string } } | undefined;
    return [
        error.response?.status,
        responseData?.message || responseData?.error?.message || error.message,
    ].filter(Boolean).join(' ');
};

export const useGetHospitalListQueries = () => {
    const { loginData } = useLoginStore();
    const clAdminToken = process.env.REACT_APP_CL_ADMIN_KEY;

    return useQuery({
        queryKey: ['getCLHospitalListQueries', loginData.id, loginData.level],
        queryFn: async () => {
            try {
                const response = await CLHospitalApi.getHospitalList(clAdminToken!);
                if (response.status === 'ok') return response.data || [];

                const responseMessage = (response as unknown as { message?: string; error?: { message?: string } }).message
                    || (response as unknown as { message?: string; error?: { message?: string } }).error?.message;
                throw new Error(responseMessage || `응답 데이터가 없습니다. status=${response.status || 'unknown'}`);
            } catch (error) {
                throw new Error(getAxiosErrorMessage(error));
            }
        },
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!clAdminToken,
    });
};
